(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Transaction', Transaction)
        .factory('TransactionIdByNumber', TransactionIdByNumber);

    Transaction.$inject = ['$resource', 'DateUtils'];

    function Transaction ($resource, DateUtils) {
        var resourceUrl =  'api/transactions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.pubDate = DateUtils.convertDateTimeFromServer(data.pubDate);
                        data.approvalDate = DateUtils.convertDateTimeFromServer(data.approvalDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    TransactionIdByNumber.$inject = ['$resource'];

    function TransactionIdByNumber ($resource) {
        var resourceUrl =  'api/transactions/id/number/:transactionNo';
        return $resource(resourceUrl, {}, {
            'get': { method: 'GET', isArray: false}
        });
    }
})();
